import styled from 'styled-components/native'

import { getTheme } from '../../../../theme/index'

type ButtonProps = {
  isSelected: boolean;
  disabled?: boolean;
}

const theme = getTheme()

export const ButtonContainer = styled.TouchableOpacity<ButtonProps>`
  background-color: ${props => props.isSelected ? theme.colors.skyBlue : '#FFFFFF'};
  border: 1px solid ${props => props.isSelected ? theme.colors.primaryDark : '#D6D8DB'};
  opacity: ${props => props.disabled ? '0.4' : '1'};
  border-radius: 10px;
  height: 52px;
  width: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ButtonText = styled.Text<ButtonProps>`
  color: ${props => props.isSelected ? theme.colors.primaryDark : '#838A94'};
  font-family: 'lato';
  padding: 30px;
  text-align: center
`
